import ActionFeedBackModal from '@/components/ActionFeedbackModal';
import Constants from '@/Constants';
import { PlaylistEvents } from '@/services/AnalyticsService';
import BotService from '@/services/BotService';
import { contentService } from '@/services/ContentService';
import { ApplicationState } from '@/store';
import { sendNewEventRequest, setBotAction } from '@/store/bot/actions';
import { clearRate, setContentRateRequest } from '@/store/rating/actions';
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import StudentRating from '../StudentRating';
import './style.scss';

interface ContentModalMessageProps {
    text?: string;
    icon?: string;
}

interface Props {
    visible: boolean;
    onHide: CallableFunction;
}

const ContentRatingModal: React.FC<Props> = (props: Props) => {
    const { visible, onHide } = props;
    const dispatch = useDispatch();
    const { strings, favoritesList, currentContent, currentLearningMap, successOnRating, errorOnRating, loading, rateData } = useSelector(
        (state: ApplicationState) => {
            return {
                strings: state.locale.data,
                favoritesList: state.favorite.favoriteList,
                currentContent: state.itens.currentData.content,
                currentLearningMap: state.learningMap.data.currentLearningMap,
                successOnRating: state.rating.submittedRating,
                errorOnRating: state.rating.errorOnSubmit,
                loading: state.rating.loading,
                rateData: state.rating.data,
            };
        },
    );

    const onRating = () => {
        const { rating } = rateData;

        if (rating === 1) {
            dispatch(sendNewEventRequest(Constants.chatbotEvents.CHATBOT_CONTENT_RATING_1));
        } else if (rating === 5) {
            const alreadyFavorited = contentService.isFavorited(currentContent.id as number, favoritesList);
            if (alreadyFavorited) {
                BotService.recommendContent(dispatch, currentContent, currentLearningMap);
                dispatch(sendNewEventRequest(Constants.chatbotEvents.CHATBOT_CONTENT_RATING_5));
            } else {
                dispatch(
                    setBotAction({
                        type: 'CONTENT_RATED',
                        rating,
                        content: currentContent,
                        message: strings.BOT_LIKE_CONTENT_ADD_FAVORITE,
                    }),
                );
            }
        }
    };

    useEffect(() => {
        if (successOnRating) {
            onRating();
        }
    }, [successOnRating]);

    useEffect(() => {
        return () => {
            dispatch(clearRate());
        };
    }, []);

    return (
        <div>
            <ActionFeedBackModal
                error={errorOnRating}
                errorMessage={strings.ERROR_WHILE_SAVE_DATA}
                loading={loading}
                onRetry={() => dispatch(setContentRateRequest(rateData))}
                success={successOnRating}
                successMessage={strings.SUCCESS_REVIEW_MESSAGE}
            />
            <Modal backdrop={true} centered dialogClassName="modal-finish-content" onHide={onHide} show={visible}>
                <Modal.Body>
                    <StudentRating
                        analyticEvent={PlaylistEvents.RATE_ITEM}
                        classification
                        entityId={currentContent.id as number}
                        entityName={currentContent.name}
                        entityType={Constants.entityTypes.CONTENT}
                        modal
                        onSendPress={onHide}
                        title={strings.LABEL_RATING_LESSON}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ContentRatingModal;
